import { Component, computed, inject, Input, input, OnInit } from '@angular/core';
import { ExistingTransactionConsumerDetailsComponent } from '@app/areas/transactions/components/existing-transaction-consumer-details/existing-transaction-consumer-details.component';
import { ExistingTransactionPaymentDetailsComponent } from '@app/areas/transactions/components/existing-transaction-payment-details/existing-transaction-payment-details.component';
import { CardModule } from 'primeng/card';
import { NgIf } from '@angular/common';
import { TruncateGuidPipe } from '@shared/pipes';
import { Order } from '@app/resources/services';
import { ExistingTransactionBasicDetailsComponent } from '@app/areas/transactions/components/existing-transaction-basic-details/existing-transaction-basic-details.component';
import { PortalTheme } from '@app/@shared/models';
import { CssValidatorService } from '@app/@shared/services/css-validator.service';

@Component({
  selector: 'app-existing-transaction-details-card',
  standalone: true,
  imports: [
    ExistingTransactionConsumerDetailsComponent,
    ExistingTransactionPaymentDetailsComponent,
    CardModule,
    TruncateGuidPipe,
    NgIf,
    ExistingTransactionBasicDetailsComponent,
  ],
  templateUrl: './existing-transaction-details-card.component.html',
  styleUrl: './existing-transaction-details-card.component.scss',
})
export class ExistingTransactionDetailsCardComponent implements OnInit {
  private readonly cssValidatorService = inject(CssValidatorService);
  transaction = input.required<Order>();

  @Input() theme: PortalTheme | undefined;

  payment = computed(() => {
    return this.transaction().OrderPayments[0];
  });

  ngOnInit(): void {
    this.setCSSCustomProperties();
  }

  private setCSSCustomProperties(): void {
    if (this.theme) {
      // Set CSS custom properties based on the theme
      document.documentElement.style.setProperty('--primary', this.theme.primary);
      document.documentElement.style.setProperty('--header-bg-primary', this.theme.header?.backgroundColor);
      document.documentElement.style.setProperty('--form-header-text-color', this.theme.form?.header?.textColor);
      document.documentElement.style.setProperty('--form-bg-color', this.theme.form?.backgroundColor);
      document.documentElement.style.setProperty('--text--color-default', this.theme.defaultTextColor);
      // Check for undefined CSS variables
      this.cssValidatorService.checkUndefinedCssVariables('ExistingTransactionDetailsCardComponent');
    }
  }
}
